import type { TAPIResponse } from 'types/api'
import type { ExperimentResponse } from 'types/experiment'
import type {
  ToolkitBahanAjarDiscoveryExperiment,
  ToolkitBahanAjarDiscoveryExperimentProperties,
} from 'types/toolkit'

import { useMutationApi } from 'utils/api'

export const useAPIParticipateBahanAjarExperiment = () => {
  return useMutationApi<
    TAPIResponse<
      ExperimentResponse<
        ToolkitBahanAjarDiscoveryExperiment,
        ToolkitBahanAjarDiscoveryExperimentProperties
      >
    >,
    Error,
    { experimentName: string; deviceId: string; userId: string }
  >(
    `${process.env.NEXT_PUBLIC_BASE_URL}${process.env.NEXT_PUBLIC_PATH_PREFIX}/api/abtest/participate`,
    {
      axiosConfig: {
        method: 'POST',
      },
    }
  )
}
